<template>
  <div>
    <div style="margin-bottom: 20px">
      <a-button type="primary" @click="addEvent">+ 新建</a-button>
    </div>
    <custom-page-table
      ref="table"
      :query-params="queryParams"
      :params-path="requestPath"
      base-key="proUrl"
      :columns="getColumns()"
    >
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm
          :title="'是否要'+(rowItem.record.optionStatus===1?'下架':'上架')+'当前套餐？'"
          @confirm="updateOptionEvent(rowItem.record)">
          <a>{{ rowItem.record.optionStatus === 1 ? '下架' : '上架' }}</a>
        </a-popconfirm>
          <a-divider type="vertical"></a-divider>
					<a @click="toPriceSetting(rowItem.record)">价格维护</a>
          <a-divider type="vertical"></a-divider>
         <a @click="toEditor(rowItem.record)">编辑</a>
    </span>
    </custom-page-table>
    <a-modal
      :title="dialogTitle"
      width="650px"
      v-model="showDialog"
      :footer="null"
      @cancel="showDialog=false"
      :confirmLoading="saveLoading"
    >
      <a-form-model
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
        ref="form"
        :model="packageForm"
        :rules="packageRules"
      >
        <a-form-model-item label="套餐名称" prop="optionName">
          <a-input v-model="packageForm.optionName" style="width: 100%" :maxLength="30"
                   placeholder="最多30个字"></a-input>
        </a-form-model-item>
        <a-form-model-item label="每张可兑" :colon="true" prop="redeemCount">
          <a-input-number v-model="packageForm.redeemCount" :min="1" :max="1000000"
                          placeholder="请输入"></a-input-number>
          <span style="margin-left: 10px">份</span>
        </a-form-model-item>
        <a-form-model-item label="兑换限制" required style="margin-bottom: 0;" v-if="couponType=='JHM'">
          <span>每&nbsp;</span>
          <a-form-model-item prop="bespeakOptionExchangeDay" style="display: inline-block;">
            <a-input-number v-model="packageForm.bespeakOptionExchangeDay"
                            :min="1" :max="365" placeholder="请输入"
                            :disabled="packageForm.optionId&&packageForm.optionId!=0"
            ></a-input-number>
            <span style="margin-left: 10px">天，可兑1次，最多可兑&nbsp;&nbsp;</span>
          </a-form-model-item>
          <a-form-model-item prop="bespeakOptionExchangeMax" style="display: inline-block;">
            <a-input-number v-model="packageForm.bespeakOptionExchangeMax"
                            :min="1" :max="5000"
                            placeholder="请输入"
                            :disabled="packageForm.optionId&&packageForm.optionId!=0"
            ></a-input-number>
            <span style="margin-left: 10px">次</span>
          </a-form-model-item>
        </a-form-model-item>
        <a-form-model-item label="补差方式" prop="addAmountWay">
          <a-radio-group v-model="packageForm.addAmountWay">
            <a-radio :value="1">在线补差</a-radio>
            <a-radio :value="2">线下补差</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="提前预约时间">
          <a-radio-group v-model="packageForm.optionAdvanceSet">
            <a-radio :style="radioStyle" :value="0">用户可随时预约使用</a-radio>
            <a-radio :style="radioStyle" :value="1">用户需提前
              <span>
                <template v-if="packageForm.optionAdvanceSet===1">
                   <a-form-model-item style="display: inline-block;margin: 0">
                     <a-input-number :min="0" v-model="packageForm.optionAdvanceDay"></a-input-number>
                     <span style="margin-left: 10px;margin-right: 10px">天</span>
                   </a-form-model-item>
                    <a-form-model-item style="display: inline-block;margin: 0">
                      <a-input-number :min="0" :max="23" v-model="packageForm.optionAdvanceHour"></a-input-number>
                      <span style="margin-left: 10px">小时</span>
                    </a-form-model-item>
                </template>
              </span>
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
      <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
        <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存设置</a-button>
      </a-form-model-item>
    </a-modal>
  </div>

</template>

<script>
import formMixin from '@/utils/mixins/formMixins'

export default {
  name: 'RelatedRecommendation',
  mixins: [formMixin],
  mounted() {
  },
  data() {
    return {
      requestPath: '',
      currentFormLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        offsetCol: { offset: 4 }
      },
      queryParams: {},
      showDialog: false,
      proposeProTypeList: [],
      packageForm: {
        optionName: '',
        addAmountWay: 1,
        redeemCount: '',
        optionAdvanceDay: 0,
        optionAdvanceHour: 0,
        optionAdvanceSet: 0,//提前预约设置 0随时预约 1提前预约天、时 ,
        bespeakOptionExchangeDay: '',//兑换限制每多少天
        bespeakOptionExchangeMax: ''//最多可兑换多少次
      },
      packageRules: {
        optionName: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' }
        ],
        addAmountWay: [
          { required: true, message: '请选择补差方式', trigger: 'blur' }
        ],
        redeemCount: [
          { required: true, message: '请输入每张券可兑换数', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '必须是大于0的正整数！', trigger: 'blur' }
        ],
        bespeakOptionExchangeDay: [
          { required: true, message: '请输入兑换限制天', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '必须是大于0的正整数！', trigger: 'blur' }
        ],
        bespeakOptionExchangeMax: [
          { required: true, message: '请输入兑换限制次', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '必须是大于0的正整数！', trigger: 'blur' }
        ]
      },
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '40px'
      },
      dialogTitle: '',
      proId: '',
      couponType: ''
    }
  },

  created() {
    this.proId = this.getPageParams().proId
    this.couponType = this.getPageParams().couponType
    this.requestPath = 'bespeak/getBespeakOptionList/' + this.proId
  },

  methods: {
    addEvent() {
      this.packageForm = {
        optionName: '',
        optionAdvanceSet: 0,
        addAmountWay: 1,
        bespeakOptionExchangeDay: '',//兑换限制每多少天
        bespeakOptionExchangeMax: ''//最多可兑换多少次
      }
      this.dialogTitle = '新建套餐'
      this.showDialog = true
    },
    toEditor(record) {
      this.getHttpServices().getProService()
        .post('bespeak/getBespeakOption/' + record.optionId)
        .then(info => {
          this.packageForm = {
            optionId: record.optionId,
            optionName: info.optionName,
            addAmountWay: info.bespeakOptionAddAmountWay,
            redeemCount: info.bespeakOptionRedeemCount,
            optionAdvanceDay: info.optionAdvanceDay,
            optionAdvanceHour: info.optionAdvanceHour,
            optionAdvanceSet: info.optionAdvanceSet ? info.optionAdvanceSet : 0,
            bespeakOptionExchangeDay: info.bespeakOptionExchangeDay ? info.bespeakOptionExchangeDay : '',//兑换限制每多少天
            bespeakOptionExchangeMax: info.bespeakOptionExchangeMax ? info.bespeakOptionExchangeMax : ''//最多可兑换多少次
          }
          this.dialogTitle = '编辑套餐'
          this.showDialog = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))

    },

    getColumns() {
      return [
        {
          title: '套餐ID',
          dataIndex: 'optionId',
          width: '160px'
        },
        {
          title: '套餐名称',
          dataIndex: 'optionName'
        },
        {
          title: '状态',
          dataIndex: 'optionStatusStr',
          width: '100px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    saveEvent() {
      this.getSubmitFormParams('form')
        .then(values => {
          this.addRequest()
        }).catch(reason => this.getLogUtils().errorWithTag('validateFormParams', this.packageForm))
    },
    addRequest() {
      this.saveLoading = true
      let params = {
        optionProId: this.proId,
        ...this.packageForm
      }
      let tips = this.packageForm.optionId ? '套餐编辑成功' : '套餐添加成功'

      this.getHttpServices().getProService().post('bespeak/saveOrUpdateBespeakOption', params)
        .then(res => {
          this.showDialog = false
          this.$message.success(tips)
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    },
    getNumberArr: function(str) {
      if (str) {
        const numbers = str.split(',')
        for (let i = 0, len = numbers.length; i < len; i++) {
          numbers[i] = Number.parseInt(numbers[i])
        }
        return numbers
      }
      return []
    },
    //上下架
    updateOptionEvent(record) {
      const params = {
        optionId: record.optionId,
        optionProId: this.proId,
        optionStatus: record.optionStatus === 1 ? 0 : 1//0 下架 1 上架
      }
      const tips = record.optionStatus === 1 ? '下架成功' : '上架成功'
      this.getHttpServices().getProService().post('bespeak/upOrDownShelvesBespeakOption', params)
        .then(res => {
          this.$message.success(tips)
          this.$refs.table.refresh(false)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toPriceSetting(record) {
      const params = {
        proId: this.proId,
        optionId: record.optionId,
        couponType: this.couponType,
        optionName: record.optionName
      }
      this.openNewPage('PackagePriceSetting', params)
    }
  }


}
</script>
<style scoped>

</style>